export const certissueConstants = {

  /*********
   증명서 신청현황 검색조건 변경
   **********/
  CERTISSUE_SEARCH_REQUEST: 'SELECT_SEARCH_REQUEST',

  /*********
   증명서 신청현황 목록 조회
   **********/
  CERTISSUE_REQUEST: 'GET_CERTISSUE_REQUEST',
  CERTISSUE_SUCCESS: 'GET_CERTISSUE_SUCCESS',
  CERTISSUE_FAILURE: 'GET_CERTISSUE_FAILURE',

  /***********
   증명서 신청현황 히스토리 관리
   ************/
  CERTISSUE_HISTORY: 'SET_CERTISSUE_HISTORY',

  /*********
   증명서 신청현황 상세 조회
   **********/
  DETAIL_REQUEST: 'GET_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'GET_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'GET_DETAIL_FAILURE',


  /*********
   증명서 신청현황 상세선택
   **********/
  SELECT_REQUEST: 'SELECT_CERTISSUE_REQUEST',

}
